export default {
    SUCCESS: 0, // 成功
    TOKEN_OUTDATED: 1000, // token过期
    NO_AUTH: 1007, // 权限不足 
    YZM_ERROR: 300009, // 验证码错误
    FETCH_FAILD: 500506, // 获取失败
    ADD_FAILD: 500507, // 添加失败
    TOKEN_NO_EXIST: 500102, // token不存在
}